export enum Vendor {
  CAR = 'car', // gogoout 汽車
  BIKE = 'bike', // gogoout 機車
  HERTZ = 'hertz', // Hertz
  OTHER = 'other', // 符合 2.0 的其他供應商，如 online travel
}

export default Vendor
